(ns manatee.info.components
  "Info. view components."
  (:require [manatee.components.modal.handlers :as modal]
            [manatee.components.modal.view :as modal-view]
            [manatee.info.subs :as subs]
            [re-frame.core :as rf]
            [rothko.button.component :as button-component]))

(defn info-modal
  []
  (let [client-version (rf/subscribe [::subs/client-version])
        server-version (rf/subscribe [::subs/server-version])]
    [modal-view/modal-container
     {:appearance  #{:primary}
      :id          :info-modal
      :dismissable true}
     [:div.layout.column
      [:h4 "About Manatee"]
      [:p (str "Client version: " @client-version)]
      [:p (str "Server version: " @server-version)]
      [button-component/button
       {:appearance #{:primary}
        :on-click   #(rf/dispatch [::modal/hide :info-modal])}
       "Ok"]]]))
